import { render, staticRenderFns } from "./hsa-overview-bucket.component.vue?vue&type=template&id=23e01b2d&"
import script from "./hsa-overview-bucket.component.vue?vue&type=script&lang=ts&"
export * from "./hsa-overview-bucket.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports